<template>
  <div>
    <div class="home-wrapper">
      <!-- 首页的头部 -->
      <Head
        :menuCode="menuCode"
        @getUserInfo="getUserInfo"
        v-model:menuInfo="menuInfo"
      />
      <!-- 首页的头部 -->
      <!-- 轮播banner -->
      <BannerList v-if="bannerItem && bannerItem.home_open" />
      <div :class="liveList && liveList.length ? 'pt173' : 'home-list-content'">
        <Live v-if="liveList && liveList.length" :bannerOpen="bannerItem.home_open" :liveList="liveList"></Live>
        <div v-for="item in sortList" :key="item.id" class="item-list" :class="classType(item.menu_code)">
          <Course
            v-if="item.menu_code == '10401' && item.home_open"
            :courseType="1"
            :menu="item"
            :userInfo="userInfo"
          />
          <SpocCourse
            v-if="item.menu_code == '10402' && item.home_open"
            :menu="item"
            :userInfo="userInfo"
          ></SpocCourse>
          <News
            :courseType="1"
            :menu="item"
            v-if="item.menu_code == '10701' && item.home_open"
          />
          <!-- 推荐教师 -->
          <TeacherList
            :menu="item"
            v-if="item.menu_code == '10501' && item.home_open"
          />
        </div>
      </div>
      <TeacherData
        v-if="dataItem && dataItem.home_open"
        :menu="dataItem"
      ></TeacherData>
      <Link v-if="footerItem && footerItem.home_open" :menu="footerItem" />
      <Footer />
    </div>
  </div>
</template>

<script>
import Head from "./../components/Head";
import DialogTeacherDetail from "./../components/DialogTeacherDetail";
import Footer from "./../components/Footer";
import Course from "./components/Course";
import SpocCourse from "./components/SpocCourse.vue";
import TeacherList from "./components/TeacherList";
import BannerList from "./components/BannerList";
import News from "./components/News";
import TeacherData from "./components/TeachData.vue";
import Live from "./components/Live.vue";
import Link from "../components/aboutLink.vue";
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    DialogTeacherDetail,
    Footer,
    SpocCourse,
    TeacherData,
    Live,
    Link,
  },
  created() {
    this.getDataList();
    this.getLive();
  },
  data() {
    return {
      menuCode: "10301",
      dataList: [],
      sortList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      menuInfo: {},
      userInfo: null,
      // authType: JSON.parse(sessionStorage.getItem('authInfo')).filter(item => item.code == '10301')[0].auth_type
    };
  },
  methods: {
    // 不同类型
    classType(code) {
      let className = ''
      switch(code) {
        case '10401':
          className = 'course-list'
          break;
         case '10701':
          className = 'news-list'
          break;
         case '10501':
          className = 'teacher-list'
          break;
      }
      return className
    },
    async getDataList() {
      const res = await this.$http.getDataList();
      console.log("首页数据", res);
      this.dataList = res;
      this.sortList = this.dataList.filter((item) => !item.home_place);
      this.footerItem = this.dataList.find(item => item.menu_code == "10303")
      this.dataItem = this.dataList.find(item => item.menu_code == "10304")
      console.log(this.dataItem);
      this.bannerItem = res.find(item => item.menu_code == "10302");
      console.log(this.bannerItem);
    },
    async getLive() {
      const res = await this.$http.getHomeLive();
      // console.log('首页直播', res)
      this.liveList = res;
    },
    getUserInfo(data) {
      this.userInfo = data;
      console.log(this.userInfo);
    },
  },
};
</script>
<style scoped lang="scss">
.home-list-content {
  position: relative;
  background: #f5f5f5;
  .live-container {
    position: absolute;
    top: 0;
    left: 0;
    background: #f5f5f5;
  }
}
.pt173 {
  // background: #f5f5f5;
  position: relative;
  background: #f5f5f5;
}
.pt200 {
  padding-top: 60px;
}

.item-list {
  background: #fff;
}

.course-list:nth-child(2n) {
  background: url("~assets/images/home/mooc_bg.jpg") no-repeat bottom;
  background-size: cover;
  background-color: #f5f5f5;
}

.teacher-list:nth-child(2n) {
  background: url("~assets/images/home/teacher_bg.png") no-repeat left;
  background-size: cover;
  background-color: #f5f5f5;
}

.news-list:nth-child(2n) {
  position: relative;
  background: url("~assets/images/home/news_bg.jpg") no-repeat left;
  background-size: cover;
}
</style>